export default __webpack_public_path__ + "static/banner-contato-daf518d2d2e534bfa8f55e15ac524cb7.jpg";